import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1k7zrom";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const deprecationFirstParagraphCss = "dsrpyc6";
const DeprecationFirstParagraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h1';
  return <Component ref={ref} {...restProps} className={classNames(deprecationFirstParagraphCss, props.className)} />;
});
const deprecationSecondParagraphCss = "d1cq4ha3";
const DeprecationSecondParagraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(deprecationSecondParagraphCss, props.className)} />;
});
export const PaymentPageDeprecationMessage = () => <Container>
    <DeprecationFirstParagraph>
      {I18n.t('publisher.billing.preparation.deprecation.message')}
    </DeprecationFirstParagraph>
    <DeprecationSecondParagraph>
      {HtmlParser(I18n.t('publisher.billing.preparation.deprecation.instructions'))}
    </DeprecationSecondParagraph>
  </Container>;

require("./deprecation_message.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./deprecation_message.js");